<div
  class="date"
  [ngClass]="['date_' + size]"
>
  <span class="date__text" [innerHTML]="'order.ship.on' | translate"></span>
  <strong class="date__date">{{ shippingDate | async }}</strong>
  <span
    class="date__text"
    translate
    [translateParams]="{
      'date': (lastDate | async) + ' 23:30'
    }"
  >{{ isGift ? 'order.ship.on.before.gift' : 'order.ship.on.before' }}</span>
</div>
